module.exports = __webpack_public_path__ + "static/media/boroughd.b2764a66.png";